const trackStore = new Map();

export const CallMediaStore = {
   addTrack: (id, track, type = 'video') => {
      const userTracks = trackStore.get(id) || {};
      userTracks[type] = track;
      trackStore.set(id, userTracks);
   },
   getTrack: (id, type = 'video') => {
      const userTracks = trackStore.get(id);
      return userTracks ? userTracks[type] : null;
   },
   removeTrack: (id, type) => {
      if (type) {
         const userTracks = trackStore.get(id);
         if (userTracks) {
            delete userTracks[type];
            trackStore.set(id, userTracks);
         }
      } else {
         trackStore.delete(id);
      }
   },
   clearStore: () => {
      trackStore.clear();
   },
};
